import { AxiosResponse } from 'axios'

import { axiosInstance } from '../axiosInstance'

export interface MobileBrowserSSOTokenRequest {
  lyra_id: string
}

export interface MobileBrowserSSOTokenResponse {
  token: string
}

const requestMobileBrowserSSOToken = (lyraId: string): Promise<AxiosResponse<MobileBrowserSSOTokenResponse>> => {
  const payload: MobileBrowserSSOTokenRequest = { lyra_id: lyraId }
  return axiosInstance.post<MobileBrowserSSOTokenResponse>('/secure/mobile-browser-sso/init/token', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
    baseURL: '',
  })
}

// Retrieves the mobile init token, which can be exchanged for a login token.
// This value is retrieved when a user clicks the Open in Lyra app banner from a mobile web browser.
// It is then passed to the mobile app via a deeplink in the query parameter mobileInitToken.
// Once on the mobile app, it will be exchanged for a token which will log the user into the mobile app.
export const getMobileBrowserSSOToken = async (lyraId: string): Promise<string> => {
  const response = await requestMobileBrowserSSOToken(lyraId)
  return response.data.token
}
